const MIN_POLYGON_VERTICES = 3;

const toNumber = value => {
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const parseCoordinate = coordinate => {
  if (Array.isArray(coordinate)) {
    const lng = toNumber(coordinate[0]);
    const lat = toNumber(coordinate[1]);
    return lat === null || lng === null ? null : { lat, lng };
  }

  if (coordinate && typeof coordinate === 'object') {
    const lat = toNumber(coordinate.lat ?? coordinate.latitude);
    const lng = toNumber(coordinate.lng ?? coordinate.longitude);
    return lat === null || lng === null ? null : { lat, lng };
  }

  return null;
};

const coordinatesAreEqual = (first, second) => first.lat === second.lat && first.lng === second.lng;

const getPolygonPath = geometry => {
  if (!geometry || geometry.type?.toLowerCase() !== 'polygon' || !Array.isArray(geometry.coordinates)) {
    return [];
  }

  const firstCoordinate = geometry.coordinates[0];
  const coordinates =
    Array.isArray(firstCoordinate) &&
    (Array.isArray(firstCoordinate[0]) || (firstCoordinate[0] && typeof firstCoordinate[0] === 'object'))
      ? firstCoordinate
      : geometry.coordinates;
  const path = coordinates.map(parseCoordinate).filter(Boolean);

  if (path.length > 1 && coordinatesAreEqual(path[0], path[path.length - 1])) {
    path.pop();
  }

  return path;
};

const toPolygonGeometry = path => {
  const coordinates = path
    .map(point => {
      const lat = toNumber(point.lat);
      const lng = toNumber(point.lng);
      return lat === null || lng === null ? null : [lng, lat];
    })
    .filter(Boolean);

  if (coordinates.length > 0) {
    coordinates.push([...coordinates[0]]);
  }

  return {
    type: 'Polygon',
    coordinates: [coordinates]
  };
};

const toPointGeometry = point => ({
  type: 'Point',
  coordinates: [Number(point.lng), Number(point.lat)]
});

const hasValidPolygon = geometry => getPolygonPath(geometry).length >= MIN_POLYGON_VERTICES;

export { MIN_POLYGON_VERTICES, getPolygonPath, hasValidPolygon, toPointGeometry, toPolygonGeometry };
